import { LocationActionType, LocationActions } from './actions';

export type CurrentPositionType = {
  lat: number;
  lng: number;
  timeStamp: number;
  accuracy?: number;
  distance?: number;
  speed?: number;
};

export const getInitialState = (): LocationState => ({
  currentPosition: undefined,
});

export type LocationState = {
  currentPosition?: CurrentPositionType;
};

export const LocationReducer = (state: LocationState, action: LocationActions): LocationState => {
  switch (action.type) {
    case LocationActionType.SET_TRACK_CURRENT_POSITION:
      return {
        ...state,
        currentPosition: action.payload,
      };
    default:
      return state;
  }
};
